import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-indicadores-vivos-home',
  templateUrl: './indicadores-vivos-home.component.html',
  styleUrls: ['./indicadores-vivos-home.component.css']
})
export class IndicadoresVivosHomeComponent implements OnInit {

  dataUsuario: any;

  constructor() { }

  ngOnInit() {
    this.dataUsuario = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
  }

}
